import { isNative } from "../native/utils"
import { useLocation } from "react-router-dom"

export const useGetUrlParams = () => {
  const { search, state: nativeParams } = useLocation()
  const searchParams = new URLSearchParams(search)
  const webParams = Object.fromEntries(searchParams.entries())

  return isNative ? nativeParams : webParams
}

export default useGetUrlParams
